class CartApi {
  constructor (ctx) {
    this.ctx = ctx
  }

  putCart = async (cartId, params) => {
    const res = await this.ctx.put(`/cart/cart/${cartId}/`, params)

    return res.data
  }

  postClearCart = async () => {
    const res = await this.ctx.post(`/cart/cart/clear_cart/`)

    return res.data
  }

  getCart = async () => {
    const res = await this.ctx.get(`/cart/cart/get_cart/`)

    return res.data
  }

  getCartItems = async () => {
    const res = await this.ctx.get(`/cart/cart_item/`)

    return res.data
  }

  postCartItem = async (params) => {
    const res = await this.ctx.post(`/cart/cart_item/`, params)

    return res.data
  }

  getCartItem = async (cartItemId) => {
    const res = await this.ctx.get(`/cart/cart_item/${cartItemId}/`)

    return res.data
  }

  putCartItem = async (cartItemId, params) => {
    const res = await this.ctx.put(`/cart/cart_item/${cartItemId}/`, params)

    return res.data
  }

  deleteCartItem = async (cartItemId) => {
    await this.ctx.delete(`/cart/cart_item/${cartItemId}/`)
  }

}

export default CartApi
